<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands =
[{"num_cand":"U2FsdGVkX18Zi5587VPIOQv1Ih0Ka1ScnNJhJP1c0qY=","cpf":"U2FsdGVkX192MvRvXfG7TYuec4UrpH1HmSZ8z+4ncdE="},{"num_cand":"U2FsdGVkX1+I4DPKtYefyKEvRITeUaWIiBnVtimuwXY=","cpf":"U2FsdGVkX18oDwLNWc+qhV9NABtYpjd0q+ZypfNUqYM="},{"num_cand":"U2FsdGVkX18VAsOAQpuLgym49ZdUNLx0yvHhG9oLZGk=","cpf":"U2FsdGVkX1+FEOzv44FEGGSRvAm45eytQtjE8BkQxfA="},{"num_cand":"U2FsdGVkX19peU+RN3MKST6Lp/5B7tof7ypsml24nQk=","cpf":"U2FsdGVkX1+qA7YBFtksE2R8lTLw6+G0eVey/2ZNVv4="},{"num_cand":"U2FsdGVkX198YTCQrcBah2/s7G2yFqi7NNh0IiMJjW8=","cpf":"U2FsdGVkX1+gsCZ/qdZEPlKmItMe0u2O73MTEWrTIyg="},{"num_cand":"U2FsdGVkX1+vHTXaLkQks+TfxB5+DI6eKUrnfolPiww=","cpf":"U2FsdGVkX1+4jI2+iWtkAKuH3m2byLDI0Oxs5xHz3iw="},{"num_cand":"U2FsdGVkX1/EB8ITDnstP5Ko7EwJzsR0t9FVUYojoR0=","cpf":"U2FsdGVkX198GFosU7/IVOaS4bCYv8oPXCZroCcwLTw="},{"num_cand":"U2FsdGVkX188t/EBEMGrvj/3E9mEYyFutuYkFSsyJ7k=","cpf":"U2FsdGVkX18mJS6kD/Nixc3/OY+uQRy8nRsxCw1GIdQ="},{"num_cand":"U2FsdGVkX19tINBwV7EFTLtaVoJb9ZBBhDPpj9Sdr3E=","cpf":"U2FsdGVkX1+m4SPdRAw/gd2+iMzkxGL6u9m4IJDx5Ts="},{"num_cand":"U2FsdGVkX19SFmb8TdjIunmDQkG/HGvLZDDR5yu0mHE=","cpf":"U2FsdGVkX19c47CVVM2RVVt/h2Ltl7IbeWUBZ/VXYo4="},{"num_cand":"U2FsdGVkX1+QY04MF9x7t+OSz6dSYjmjndfbSLri57I=","cpf":"U2FsdGVkX19Q9wXBh8aZiGttqVsaMOKnb04Hxe1QHbQ="},{"num_cand":"U2FsdGVkX19xBN76tOdTIW1lBMAgMbey4a6UXQ8ukwQ=","cpf":"U2FsdGVkX1+cDaxlCAAA2MDGsN+ALbGS2gWw6Wn11n4="},{"num_cand":"U2FsdGVkX18T+6XJaJKmWExU39xA8GJchQCWOBD9bic=","cpf":"U2FsdGVkX18OWUYobvE2MW/HLza+68GGYdNhjPHAUc4="},{"num_cand":"U2FsdGVkX1/Y4kUVFNWhEdwJZrGwwfDNCdNK2O+2yKw=","cpf":"U2FsdGVkX1/XmyLkLTLp/hR5ZtcYe48kQ11zCiaBD+c="},{"num_cand":"U2FsdGVkX1/vSsow8VLeuX2Ga9ekyktA+77OqmFkr/o=","cpf":"U2FsdGVkX18p/8XOe9qSm2+cHUuFNWhpvVriIGzFrCU="},{"num_cand":"U2FsdGVkX19sr+El85K490W56AoJIBeUhFUNB+LO/eQ=","cpf":"U2FsdGVkX19l5VmHkYO6ILgN4CikvnH8NH+IrRFL+7E="},{"num_cand":"U2FsdGVkX1+BK9zg8t8UFO58PNdMKQbivaEIxnFHKbY=","cpf":"U2FsdGVkX19MlLV/jqO/be49Waz+ntv2rLRvepCEtaM="},{"num_cand":"U2FsdGVkX18/AgIZfGnQ/EKX5prUXm21D3Y3TODUNBQ=","cpf":"U2FsdGVkX1+vrHUlm07DrV06ZCYOsfdnjpZL1YfYvRU="},{"num_cand":"U2FsdGVkX19rZg244hLuYxsxhJIe8mirXWAhGaDMI9Q=","cpf":"U2FsdGVkX18TJTGHJv493+8tGPoQh+RRGXKsnnZKsV0="},{"num_cand":"U2FsdGVkX18fGT9l+t+9L+0duAEBijo+to2LMvWN/ZY=","cpf":"U2FsdGVkX1+6dEE/qXsEptJmlx4GRYwTbn+R4ZX+bIo="},{"num_cand":"U2FsdGVkX18nfEltyBKzSXoZ2mz4v2X+QckNMAr/3+g=","cpf":"U2FsdGVkX18oxeWepu3ywrOYPayr0yNB6QjTLW++sYg="},{"num_cand":"U2FsdGVkX18mF1k96WzqnQK/XMstAyv8djfROLgf7Gc=","cpf":"U2FsdGVkX1+rTD6PzXV3Xe4m48f1pia9lDQAYHiam5Y="},{"num_cand":"U2FsdGVkX19DkLniU2we0I1OIxAU4HUUIQsru47PIqs=","cpf":"U2FsdGVkX18mrR20VlTZlL5ceEmyQl6J9ZjPP171lhs="},{"num_cand":"U2FsdGVkX1+EylOvuwuWIe103qMKD7gt23uNi6bCN+o=","cpf":"U2FsdGVkX1+OCsTyke0Tg41ccD0PXTxZbQNPVtnZA1Y="},{"num_cand":"U2FsdGVkX1+IN2fChjoa5LARya8hToevBZhGrGfY7N8=","cpf":"U2FsdGVkX18pp8luvnBe+HnW78j2tSngLw+y67OQjjk="},{"num_cand":"U2FsdGVkX19fsmqqneSuV8PCYxm0JM8ocPjMhJcF/Ec=","cpf":"U2FsdGVkX1/+E2Ad2sPoaID/34PgWaGQJtt7KQE8QLU="},{"num_cand":"U2FsdGVkX1/262gDsa7MigZWIha9mMTUJxar04o6H6c=","cpf":"U2FsdGVkX19wEoDQwdVo18c1oNyuBGmDoJuSOh3/Tj4="},{"num_cand":"U2FsdGVkX19/MVca8Y00giVdvrDV54VSTT7ac7+WraY=","cpf":"U2FsdGVkX1/6dXvtXA8KjrSHXX73WSro4w9acouUW8g="},{"num_cand":"U2FsdGVkX1+XABsJmfUmWBlM2rQqph+cpVQrOIl7nIY=","cpf":"U2FsdGVkX18++i+2fxI6FNSR5hdTyIHrCt6bY4j1obU="},{"num_cand":"U2FsdGVkX1+a8/Rgb/91thhbS66x8OV73CXqu+i6emQ=","cpf":"U2FsdGVkX19ugTeEmgInK4CqaT3uYx1bQQOlpNu8jsg="},{"num_cand":"U2FsdGVkX19HeRDt8KQRg/K17pFG966JAv3r/B6cD7U=","cpf":"U2FsdGVkX18DCTVItb8DolyzzHz/R97J71iP0Sjc0IQ="},{"num_cand":"U2FsdGVkX1+p8qur2s9G70Hvs43wqIsx9dR80HxqOCE=","cpf":"U2FsdGVkX19o4IoQRfLiBr8hE/v2FSt1k4Jp/ZMDFDg="},{"num_cand":"U2FsdGVkX19GNtbk1whr5hJwdQM++i7j+Tma+zrj6AU=","cpf":"U2FsdGVkX1/Yw6YeovF7NuoRggs3WpO+6X6ZRN++KXE="}]

      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2201/2201_rec_tit/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
